import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import * as _ from 'lodash';

import { ISlimScrollOptions } from 'ng2-slimscroll';
import { MemberService } from './../member.service';
import { MessageEvent, HandleSideMenuWithAuth, SignInEvent, OpenFrameEvent, LoaderEvent, SidemenuSubCategory, HiddenFooter, SetAllMemberCheck } from './../../shared/message.event';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';
import { BlockSlots } from '../../shared/blockSlots';
import { BaseMember } from './../base-member';
// import * as jsonexport from "jsonexport/dist"
@Component({
  selector: 'app-member-list',
  templateUrl: './member-list.component.html',
  styleUrls: ['./member-list.component.css'],
  providers: [
    MemberService,
    MessageEvent,
    SignInEvent,
    OpenFrameEvent,
    LoaderEvent,
    SidemenuSubCategory,
    HiddenFooter,
    SetAllMemberCheck,
    HandleSideMenuWithAuth
  ]
})
export class MemberListComponent extends BaseMember implements OnInit {
  private stringConstants = CONSTANT_MESSAGES;
  private shouldSlide: boolean = false;
  private hideEdit: boolean;
  private windowHeight = window.innerHeight;
  private topNav = 56;
  private midNav = 45;
  private footer = 35;
  private container = 20;
  private height: any;
  private scrollOptions: ISlimScrollOptions;
  private divHeight = 30;
  private member: any = {
    'vendorId': '',
    'members': []
  };
  private showFilterPreference = false;
  private selectItem = false;
  private filterSendInvite = false;
  private noMemberAvailableInFilter = false
  @ViewChild('fileUploadInput')
  fileUploadInputVariable: any;

  @ViewChild('bookingFileUploadInput')
  fileBookingUploadInputVariable: any;
  @ViewChild('searchInput')
  searchInputVariable: any;
  private exp;
  private totalSizeOfList = 0;
  private onePagePerItem = 10; // It will set by vendor configuration object
  private filterPara = '';
  private pageOptions = {
    currentPage: 1,
    noOfPageItem: this.onePagePerItem
  };
  private message = '';
  private clubName = '';
  private showFilterGroup = false;
  private showOnBoardingFlag = false;
  private successfullyAddedMembers = [];
  private failedLogObj = [];
  @ViewChild('memberTable')
  tableVariable: any;
  private addedMembers: any = {
    'vendorId': '',
    'members': [],
    'clubName': '',
    isWaitForCallback: true
  };
  private sentInvitesList = [];
  private sendInviteFlag = false;
  private setChecked = [];
  private sendInviteFliterList = [{ name: 'Sent', status: true }, { name: 'Not Sent', status: false }];
  private sendMailToAddedMembersList = [];

  private blockSlots = new BlockSlots();
  constructor(private router: Router, private memberService: MemberService, private appService: AppService,
    private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private signInEvent: SignInEvent,
    private loaderEvent: LoaderEvent, private sidemenuSubCategory: SidemenuSubCategory, private hiddenFooter: HiddenFooter, private handleSideMenuWithAuth: HandleSideMenuWithAuth, private setAllMemberCheck: SetAllMemberCheck) {
    super();
    this.popUpMessage = 'Is Payment Done';
    this.hideEdit = false;
    this.scrollOptions = {
      barBackground: "#343a40", barOpacity: "0.6", position: "right",
      barWidth: "6", barBorderRadius: "5", barMargin: "1px 1px", gridBackground: "#adb5bd", gridOpacity: "1", gridWidth: "4", gridBorderRadius: "10", gridMargin: "1px 2px"
    };
    this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight)) + 'px';
    this.exp = false;
    this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
    this.noMemberAvailable = true;
  }

  ngOnInit() {
    let obj = {
      category: 'All Members',
      menu: 'Members'
    };
    this.sidemenuSubCategory.fire(obj);
    this.showOnBoardingFlag = false;
    if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        this.clubName = subVendor.clubName;
      }
    } else {
      this.clubName = this.vendor.clubName;
    }
    // Temporary Fixed issue for sub menu of side menu
    if (this.vendor.role == CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      this.appService.getFacilityByClub(this.vendor._id);
    } else if (this.vendor.role == CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        this.appService.getFacilityByClub(subVendor._id);
      }
    } else {
      this.appService.getFacilityByClub(this.vendor.vendorId);
    }
    this.getFacilityListForMemberFilter(this);
    this.getGroupListForFilter(this);
    this.pagination(this.pageOptions, 1);
    this.emitOpenFrameEvent();
    this.emitTypeBroadcast();
    this.registerTypeBroadcast();
    this.makeAddedMemberListClear()
  }

  /**
   * Fetch MemberList with respect to condo
   */

  getMemberListByVendor(vendorObj) {
    this.loaderEvent.fire(false);
    let that = this;
    return this.appService.getListOfMember(vendorObj).then((result: any) => {
      console.log('Member list result');
      // console.log(result);
      if (result.status === 'SUCCESS') {
        // this.getStaffListByVendor();
        console.log(result.memberList);
        this.memberList = result.memberList;
        this.totalSizeOfList = result.total;
        this.noMemberAvailable = (result.total > 0);
        this.memberList.map(function (mem) {
          if (mem.isInviteSent) {
            mem.sendInviteFlag = true;
          } else {
            mem.sendInviteFlag = false;
          }
          if (!mem.isBlackListed) {
            mem.enable = 'Active';
          } else {
            mem.enable = 'Inactive';
          }
          mem.isChecked = false;
          mem.signedUpOn = that.utilityFunctions.maketimeZoneOfsetDate(mem.signedUpOn).format('DD/MM/YYYY');
          if (mem.hasLeftService) {
            mem.leftServiceDate = that.utilityFunctions.maketimeZoneOfsetDate(mem.leftServiceDate).format('DD/MM/YYYY');
          }
          mem.showDetails = true;
        });
        console.log(this.memberList.length)
        if (this.memberList.length === 0) {
          this.noMemberAvailable = false;
        } else {
          this.noMemberAvailable = true;
          this.setCheckedList();
        }
        if (vendorObj['filters'].length > 0) {
          this.noMemberAvailableInFilter = true;
        } else {
          this.noMemberAvailableInFilter = false;
        }
        this.setAllMemberCheck.fire(true);
        that.loaderEvent.fire(true);
      }

      this.sendInviteFlag = false;
      return this.memberList;
    }).catch((err) => {
      this.popUpMessage = err;
      this.loaderEvent.fire(true);
      return err;
    });
  }

  // getStaffListByVendor() {
  //   let obj = {
  //     vendorId: this.vendor._id
  //   }
  //   let numberOfPage = this.totalSizeOfList / this.pageOptions.noOfPageItem;
  //   let searchTerm = (this.searchMember + '').trim().toUpperCase();
  //   if ((numberOfPage == this.pageOptions.currentPage) || searchTerm) {


  //     this.appService.getListOfStaff(obj).then((result: any) => {
  //       if (result.vendorData) {
  //         result.vendorData.forEach(staff => {
  //           staff.showDetails = true;
  //           staff['groupActivity'] = staff.activities.map(activity => {
  //             return activity.activityName;
  //           })
  //           staff['type'] = staff.role;


  //           if (searchTerm &&
  //             (staff.firstName.toUpperCase() === searchTerm ||
  //               staff.lastName.toUpperCase() === searchTerm ||
  //               staff.type.toUpperCase() === searchTerm ||
  //               staff.role.toUpperCase() === searchTerm)) {
  //             if (this.staffAlreadyExist(staff._id) == -1) {
  //               this.memberList.push(staff);
  //             }
  //             // console.log('this.memberList')
  //             // console.log(this.memberList)
  //           } else if (!searchTerm) {
  //             if (this.staffAlreadyExist(staff._id) == -1) {
  //               this.memberList.push(staff);
  //             }
  //             // console.log('this.memberList')
  //             // console.log(this.memberList)
  //           }
  //         })
  //       }
  //     })


  //   }
  // }
  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.signInEvent.fire('block');
    this.hiddenFooter.fire(isShow);
  }

  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }

  /**
   * while menu slide left to right as well as we shift header, footer and body too by broadcaster
   */

  registerTypeBroadcast() {
    this.messageEvent.on().subscribe(message => {
      this.shouldSlide = message;
    });
  }


  convertArrayOfObjectsToCSV(args) {
    // console.log(args);
    let result
      , ctr
      , keys
      , columnDelimiter
      , lineDelimiter
      , data;

    data = args.data || null;
    // console.log(data);
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';
    keys = Object.keys(data[0]);
    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;
    // console.log(result)
    data.forEach(function (item) {
      ctr = 0;
      keys.forEach(function (key) {
        if (ctr > 0) result += columnDelimiter;

        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });
    return result;
  }

  exportMembers() {
    let vendorObj = {
      vendorId: this.vendor._id
    }
    let exportList = [];
    this.appService.getListOfMember(vendorObj).then((result: any) => {
      result.memberList.forEach(member => {
        exportList.push(member)
      })
      return exportList;
    }).then((exportList) => {
      return this.appService.getListOfStaff(vendorObj).then((result: any) => {
        if (result.vendorData) {
          result.vendorData.forEach(staff => {
            exportList.push(staff);
          })
        }
        return exportList;
      })

    }).then((exportList) => {
      var data, filename, link;

      let objectToConvert = exportList.map(member => {
        let type = member.type ? member.type : 'NA';
        let group = member.groups ? member.groups : 'NA';
        let types = type.split(',').map(type => { return type });

        return {
          "Membership Id": member.membershipId ? member.membershipId : 'NA',
          "First Name": member.firstName,
          "Last Name": member.lastName,
          "Email Id": member.emailId,
          "Country Code": member.countryCode,
          "Contact Number": member.contactNumber,
          "Address Line 1": member.addressLine1 ? member.addressLine1 : 'NA',
          "Address Line 2": member.addressLine2 ? member.addressLine2 : 'NA',
          "Notes": member.note ? member.note : 'NA',
          "Type 1": types[0] ? types[0] : 'NA',
          "Type 2": types[1] ? types[1] : 'NA',
          "Type 3": types[2] ? types[2] : 'NA',
          "Type 4": types[2] ? types[3] : 'NA',
          "Type 5": types[2] ? types[4] : 'NA',
          "Group 1": group[0] ? group[0] : 'NA',
          "Group 2": group[1] ? group[1] : 'NA',
          "Group 3": group[2] ? group[2] : 'NA',
          "Group 4": group[3] ? group[2] : 'NA',
          "Group 5": group[4] ? group[2] : 'NA',
        }
      })
      var csv = this.convertArrayOfObjectsToCSV({
        data: objectToConvert
      });
      if (csv == null) return;
      filename = 'members.csv';

      if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv;
      }
      data = encodeURI(csv);

      link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      link.click();
    })
  }
  /**
   * Upload only csv file
   * sequence is emailId, contactNumber, membershipId
   */

  uploadFile(event, popUpObj, showLog) {
    this.loaderEvent.fire(false);
    let input = event.target;
    let file = input.files[0];
    let that = this;
    that.sendMailToAddedMembersList = [];
    this.successfullyAddedMembers = [];
    if (file.name.indexOf('.csv') !== -1) {
      this.memberService.getMembersFromFile(input).then((result1: any) => {
        that.member.members = result1.members;
        that.failedLogObj = result1['logList'];
        if ((!result1.members || (result1.members && result1.members.length <= 0)) && (!result1['logList'] || (result1['logList'] && result1['logList'].length <= 0))) {
          this.popUpMessage = 'There is no record to add member';
          this.loaderEvent.fire(true);
          popUpObj.showChildModal();

          return;
        }
        if (this.member.members && this.member.members.length > 0) {
          this.member.vendorId = this.vendor._id;
          this.memberService.uploadMember(this.member).then((result: any) => {
            if (result.status === 'SUCCESS') {
              if (result.notAdded && result.notAdded.length > 0) {
                result.notAdded.filter(function (rec) {
                  that.failedLogObj.push({ obj: rec, logList: rec['reason'] });
                });
              }
              if (result.added && result.added.length > 0) {
                result.added.filter(function (rec) {
                  that.successfullyAddedMembers.push({ obj: rec, logList: CONSTANT_MESSAGES.REMARK_MEMBER });
                });
                result.added.filter(function (rec) {
                  that.sendMailToAddedMembersList.push({ obj: rec, logList: CONSTANT_MESSAGES.REMARK_MEMBER });
                });
              }
              if (result.updated && result.updated.length > 0) {
                result.updated.filter(function (rec) {
                  that.successfullyAddedMembers.push({
                    obj: rec, logList: 'member updated Successfully'
                  });
                });
              }
              if (result.typeUpdated && result.typeUpdated.length > 0) {
                result.typeUpdated.filter(function (rec) {
                  that.successfullyAddedMembers.push({ obj: rec, logList: 'member type updated Successfully' });
                });
              }
              if (result.groupAdded && result.groupAdded.length > 0) {
                result.groupAdded.filter(function (rec) {
                  that.successfullyAddedMembers.push({ obj: rec, logList: 'Member is added in group Successfully' });
                });
              }
              that.pagination(that.pageOptions, 1);
              that.loaderEvent.fire(true);
              showLog.showChildModal(1, that.failedLogObj, that.successfullyAddedMembers, [], [], []);
            } else {
              that.loaderEvent.fire(true);
              that.popUpMessage = result['message'];
              popUpObj.showChildModal();
            }
          });
        } else {
          that.loaderEvent.fire(true);
          showLog.showChildModal(1, that.failedLogObj, that.successfullyAddedMembers, [], [], []);
        }
      });
    } else {
      this.loaderEvent.fire(true);
      this.popUpMessage = CONSTANT_MESSAGES.FILE_NOT_SUPPORT;
      popUpObj.showChildModal();
    }
  }

  onNotify() {
    this.router.navigate(['/']);
  }

  resetFileUploadInput() {
    this.fileUploadInputVariable.nativeElement.value = '';
  }

  resetFileBookingUploadInput() {
    this.fileBookingUploadInputVariable.nativeElement.value = '';
  }


  /**
  * Search element will expand on search icon
  */

  expand() {
    if ((this.searchMember + '').trim()) {
      this.pagination(this.pageOptions, 1);
    } else {
      this.searchMember = '';
      if (this.exp) {
        this.pagination(this.pageOptions, 1);
      }
      this.exp = !this.exp;
    }
  }
  /**
  * Go to add member page
  */
  redirectToAddMember() {
    console.log('redirect called')
    if (localStorage.getItem('vendor')) {
      this.router.navigate(['/addmember']);
    }
  }
  /**
  * Go to create group page
  */
  redirectToCreateGroup() {
    if (localStorage.getItem('vendor')) {
      this.router.navigate(['/creategroup']);
    }
  }
  /**
  * Get vendor details
  */
  getVendorDetails() {
    try {
      let obj = {
        vendorId: this.vendor._id
      };
      this.memberService.getVendorDetails(obj).then((result: any) => {
        if (result.status === 'SUCCESS') {
          this.vendor = result.vendor[0];
        } else { }
      });
    } catch (err) { }
  }
  /**
   * Set filter , search and pagination to get member list
   *
   * @param {any} pageOptions
   * @param {any} pageNo
   *
   * @memberof MemberListComponent
   */
  pagination(pageOptions, pageNo) {
    this.filterState = this.filterPara;
    if (pageOptions) {
      this.pageOptions = pageOptions;
    }
    // staff can not see all members
    let vendorObject = this.setVendorIdAsPerRole(this, pageNo);
    this.message = CONSTANT_MESSAGES.NO_MEMBER_ADDED_MESSAGE;
    this.tableVariable.currentPage = pageNo ? pageNo : this.pageOptions.currentPage;
    switch (this.filterPara) {
      case 'Inactive':
        vendorObject['filters'].push({
          type: 'isDeactivated',
          values: true
        });
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'DisabledFacility':
        vendorObject['filters'].push({
          type: 'disabled',
          values: this.facilityFilter,
          applyAll: false
        });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.facilityFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'Prefernces':
        vendorObject['filters'].push({
          type: 'facilityPreference',
          values: this.preferenceFilter,
          applyAll: false
        });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.preferenceFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'Groups':
        vendorObject['filters'].push({
          type: 'group',
          values: this.groupFilter,
          applyAll: false
        });
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.groupFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
      case 'SentInvite':
        if (this.inviteStatusFilter.indexOf(true) >= 0 && this.inviteStatusFilter.indexOf(false) < 0) {
          vendorObject['filters'].push({
            type: 'isInviteSent',
            values: true
          });
        }
        if (this.inviteStatusFilter.indexOf(false) >= 0 && this.inviteStatusFilter.indexOf(true) < 0) {
          vendorObject['filters'].push({
            type: 'isInviteSent',
            values: false
          });
        }
        if (this.inviteStatusFilter.length == 0) {
          vendorObject['filters'] = [];
        }
        this.filterStateSubMenuList = JSON.parse(JSON.stringify(this.inviteStatusFilter));
        this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
        break;
    }
    if ((this.searchMember + '').trim()) {
      vendorObject['filters'].push({
        type: 'search',
        values: this.searchMember
      });
      this.message = CONSTANT_MESSAGES.NO_RECORD_FOUND;
    }
    this.getMemberListByVendor(vendorObject).then(() => {
      // this.getStaffListByVendor()
    })
  }
  /**
   * Add facility in list to filter by disable facility
   */
  addFacilityForFilter(e, facilityId) {
    this.utilityFunctions.addFacilityForFilter(this, e, facilityId);
  }
  /**
   * Add group in list to filter by group
   */
  addGroupForFilter(e, groupId) {
    this.utilityFunctions.addGroupForFilter(this, e, groupId);
  }
  /**
   * Add facility in list to filter by preference
   */
  addPreferencesForFilter(e, facilityId) {
    this.utilityFunctions.addPreferencesForFilter(this, e, facilityId);
  }
  /**
   * Select filter criteria
   */

  addInviteStatusForFilter(e, status) {
    this.utilityFunctions.addInviteStatusForFilter(this, e, status);
  }
  setFilterCriteria(para) {
    this.utilityFunctions.setFilterCriteria(this, para);
  }
  /**
   * Maintain filter state
   */
  maintainFilterState() {
    this.utilityFunctions.maintainFilterState(this);
  }

  showOnBoarding() {
    this.showOnBoardingFlag = true;
    this.router.navigate(['/on-boarding-dashboard']);
  }

  downloadTemplatePopup(downloadTemplate) {
    downloadTemplate.showChildModal();
  }

  sendMailToAddedMembers(popupObj, showLog) {
    this.loaderEvent.fire(false);
    let that = this;
    this.sentInvitesList = [];
    that.addedMembers.vendorId = this.vendor._id;
    that.addedMembers.clubName = this.vendor.clubName;
    that.addedMembers.members = [];
    let obj;
    if (that.sendMailToAddedMembersList && that.sendMailToAddedMembersList.length > 0) {
      that.sendMailToAddedMembersList.forEach(function (rec) {
        that.addedMembers.members.push(rec['obj']);
      });
      that.addedMembers.isWaitForCallback = true;
      this.memberService.sendMailToMembers(that.addedMembers).then((result: any) => {
        if (result.status === 'SUCCESS') {
          this.makeAddedMemberListClear();
          this.setSendInviteFlag();
          if (result.members && result.members.length > 0) {
            that.sentInvitesList = _.cloneDeep(result.members);
            this.pagination(this.pageOptions, 1);
            that.successfullyAddedMembers = [];
            that.sendMailToAddedMembersList = [];
            showLog.showChildModal(2, [], [], that.sentInvitesList, [], []);
          }
        } else {
          this.loaderEvent.fire(true);
          that.popUpMessage = result['message'];
          popupObj.showChildModal();
        }
        this.sendInviteFlag = true;
      });
    } else {
      this.loaderEvent.fire(true);
      that.popUpMessage = 'Please select member';
      popupObj.showChildModal();
    }
  }

  uploadCsv(event, popupObj, showLog) {
    if (event.flag) {
      this.uploadBookingFile(event.event, popupObj, showLog);
    } else {
      this.uploadFile(event.event, popupObj, showLog);
    }
  }

  uploadBookingFile(event, popupObj, showLog) {
    let input = event.target;
    let file = input.files[0];
    let that = this;
    let obj;
    let bookingLogList = [];
    let confirmBookingList = [];
    let bookingList = [];
    if (file.name.indexOf('.csv') !== -1) {
      this.memberService.getBookingsFromFile(input).then((result) => {
        if (result['message'] === CONSTANT_MESSAGES.INVALID_FILE_COLUMNS) {
          this.popUpMessage = CONSTANT_MESSAGES.INVALID_FILE_COLUMNS;
          popupObj.showChildModal();
        } else if ((!result['loglList'] || (result['loglList'] && result['loglList'].length <= 0)) && (!result['booking'] || (result['booking'] && result['booking'].length <= 0))) {
          this.popUpMessage = 'There are no records to do bookings';
          popupObj.showChildModal();
          return;
        } else {
          bookingLogList = result['loglList'];
          bookingList = result['booking'];
          if (bookingList && bookingList.length > 0) {
            let requestObj = {
              'vendorId': this.vendor._id,
              'bookings': bookingList
            }
            this.loaderEvent.fire(true);
            this.memberService.uploadBookings(requestObj).then((result: any) => {
              if (result.status === 'SUCCESS') {
                this.makeAddedMemberListClear();
                if (result.notAdded && result.notAdded.length > 0) {
                  result.notAdded.filter(function (rec) {
                    bookingLogList.push({ obj: rec, logList: rec['reason'] });
                  });
                }
                if (result.added && result.added.length > 0) {
                  result.added.filter(function (rec) {
                    confirmBookingList.push({ obj: rec, logList: rec['reason'] });
                  });
                }
                this.loaderEvent.fire(true);
                showLog.showChildModal(3, [], [], [], confirmBookingList, bookingLogList);
              } else {
                that.loaderEvent.fire(true);
                that.popUpMessage = result['message'];
                popupObj.showChildModal();
              }
            });
          } else {
            showLog.showChildModal(3, [], [], [], confirmBookingList, bookingLogList);
          }
        }
      });
    } else {
      this.popUpMessage = CONSTANT_MESSAGES.FILE_NOT_SUPPORT;
      popupObj.showChildModal();
    }
  }

  addMemberInInviteList(memberObj) {
    if (memberObj.isChecked) {
      this.successfullyAddedMembers.push({ obj: memberObj, logList: CONSTANT_MESSAGES.REMARK_MEMBER });
      this.setChecked.push(memberObj.userId);
    } else {
      _.remove(this.successfullyAddedMembers, function (n) {
        return n.obj.userId === memberObj.userId;
      });
      _.remove(this.setChecked, function (n) {
        return n === memberObj.userId;
      });
      _.remove(this.sendMailToAddedMembersList, function (n) {
        return n.obj.userId === memberObj.userId;
      });

      if (this.tableVariable.allInGroup) {
        this.tableVariable.allInGroup = false;
      }
    }
    if (this.successfullyAddedMembers.length === 0) {
      this.tableVariable.allInGroup = false;
    } else {
      this.successfullyAddedMembers = _.uniqBy(this.successfullyAddedMembers, function (e) {
        return e.obj.contactNumber;
      });
      this.successfullyAddedMembers.forEach(member => {
        this.sendMailToAddedMembersList.push(member)
      });
    }
    this.setSendInviteFlag();
  }

  makeAllMemberForInvite(memberList: any) {
    this.setChecked = this.setChecked.concat(memberList);
    if (!this.tableVariable.allInGroup) {
      this.setChecked = _.difference(this.setChecked, memberList);
      this.removeMembersFromSuccessfullyAddedMembers(memberList);
    } else {
      this.setUserListToSendInvite();
    }
    this.setSendInviteFlag();
  }

  removeMembersFromSuccessfullyAddedMembers(memberList) {
    let that = this;
    this.successfullyAddedMembers = this.successfullyAddedMembers.filter(function (rec: any) {
      if (memberList.indexOf(rec.obj.userId) >= 0) {

      } else {
        return rec;
      }
    });
  }

  setUserListToSendInvite() {


    // for (let rec of this.setChecked) {
    //   for (let mem of this.memberList) {
    //     if (rec === mem.userId && !mem.sendInviteFlag) {
    //       this.successfullyAddedMembers.push({ obj: mem, logList: CONSTANT_MESSAGES.REMARK_MEMBER });
    //       break;
    //     }
    //   }
    // }
    let i = 0;


    while (i <= this.memberList.length - 1) {
      if (this.setChecked.indexOf(this.memberList[i].userId) >= 0 && !this.memberList[i].sendInviteFlag) {
        this.successfullyAddedMembers.push({ obj: this.memberList[i], logList: CONSTANT_MESSAGES.REMARK_MEMBER });
      }
      i++;
    }




    this.successfullyAddedMembers = _.uniqBy(this.successfullyAddedMembers, function (e) {
      return e.obj.contactNumber;
    });
    this.successfullyAddedMembers.forEach(member => {
      this.sendMailToAddedMembersList.push(member)
    });
  }

  setCheckedList() {
    let flagAllChecked = true;
    for (let rec of this.setChecked) {
      for (let mem of this.memberList) {
        if (rec === mem.userId) {
          mem.isChecked = true;
          break;
        }
      }
    }
    for (let mem of this.memberList) {
      if (!mem.isChecked) {
        flagAllChecked = false;
        break;
      }
    }
    if (flagAllChecked) {
      this.tableVariable.allInGroup = true;
    } else {
      this.tableVariable.allInGroup = false;
    }
  }

  makeAddedMemberListClear() {
    this.successfullyAddedMembers = [];
    this.memberList.map(function (member: any) {
      member.isChecked = false;
    });
    this.tableVariable.allInGroup = false;
    this.setChecked = [];
  }

  setSendInviteFlag() {
    if (this.successfullyAddedMembers && this.successfullyAddedMembers.length > 0) {
      this.sendInviteFlag = true;
    } else {
      this.sendInviteFlag = false;
    }
  }

  staffAlreadyExist(id) {
    return this.memberList.map(member => {
      return member.userId;
    }).indexOf(id)
  }

  uploadBLockSlotFile(event, popupObj, ) {
    let file = event.target.files[0];
    this.popupTitle = '';
    let that = this;
    let reqObj = {
      'vendorId': this.vendor._id,
      'facilityData': []
    }
    if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        reqObj.vendorId = subVendor._id;
      }
    } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
      reqObj.vendorId = this.vendor.vendorId;
    } else {
      reqObj.vendorId = this.vendor._id;
    }
    if (file.name.indexOf('.csv') !== -1) {
      this.blockSlots.readBlockSlotFile(event).then((result: any) => {
        if (result.blockingList.length > 0) {
          reqObj.facilityData = that.blockSlots.calculateBlockSlots(result.blockingList, this.vendor._id);
          if (reqObj.facilityData.length > 0) {
            this.loaderEvent.fire(false);
            that.appService.blockDates(reqObj).then((result1: any) => {
              this.loaderEvent.fire(true);
              that.popUpMessage = result1.message;
              if (result1.status == 'SUCCESS') {
                this.popupTitle = 'Confirmation';
              }
              popupObj.showChildModal();
            }
            );
          }
        } else {
          this.popupTitle = '';
          that.popUpMessage = 'Does not have proper data to block slots';
          popupObj.showChildModal();
        }
      });
    } else {
      this.popUpMessage = CONSTANT_MESSAGES.FILE_NOT_SUPPORT;
      popupObj.showChildModal();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/member/member-list/member-list.component.ts